import script from "./ApiApplicationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiApplicationDialog.vue?vue&type=script&setup=true&lang=js"

import "./ApiApplicationDialog.vue?vue&type=style&index=0&id=a7aca470&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7aca470"]])

export default __exports__